import Api from "utils/api";

export const postContactInfo = async (formData: any) => {
  return Api.patch(`accounts/contact/update-contact-info/`, formData).then((res) => res.data);
};

export const getContactInfo = async (data: any) => {
  return Api.get(`accounts/contact/contact-info`).then((res) => res.data);
};
